import axios from "axios";

export const FETCH_QUESTIONS_REQUEST = "FETCH_QUESTIONS_REQUEST";
export const FETCH_QUESTIONS_SUCCESS = "FETCH_QUESTIONS_SUCCESS";
export const FETCH_QUESTIONS_FAILURE = "FETCH_QUESTIONS_FAILURE";

export const UPDATE_QUESTIONS_REQUEST = "UPDATE_QUESTIONS_REQUEST";
export const UPDATE_QUESTIONS_SUCCESS = "UPDATE_QUESTIONS_SUCCESS";

export const DELETE_ALL_QUESTION_REQUEST = "DELETE_ALL_QUESTION_REQUEST";

export const ADD_ANSWER_REQUEST = "ADD_ANSWER_REQUEST";
export const ADD_ANSWER_SUCCESS = "ADD_ANSWER_SUCCESS";

export const UPDATE_ANSWER_REQUEST = "UPDATE_ANSWER_REQUEST";
export const UPDATE_ANSWER_SUCCESS = "UPDATE_ANSWER_SUCCESS";

export const QUESTIONS_EXPORT_REQUEST = "QUESTIONS_EXPORT_REQUEST";
export const QUESTIONS_EXPORT_RESPONSE = "QUESTIONS_EXPORT_RESPONSE";

export const fetchQuestionsRequest = () => {
    return {
        type: FETCH_QUESTIONS_REQUEST,
    };
};

export const fetchQuestionsSuccess = (questions) => {
    return {
        type: FETCH_QUESTIONS_SUCCESS,
        payload: questions,
    };
};

export const fetchQuestionsFailure = (error) => {
    return {
        type: FETCH_QUESTIONS_FAILURE,
        payload: error,
    };
};

export const questionsExportRequest = () => {
    return {
        type: QUESTIONS_EXPORT_REQUEST,
    };
};

export const fetchQuestions = (params) => {
    return async (dispatch) => {
        dispatch(fetchQuestionsRequest());
        try {
            const response = await axios.get("/questions", { params });
            dispatch(fetchQuestionsSuccess(response.data));
        } catch (error) {
            dispatch(fetchQuestionsFailure(error.message));
        }
    };
};

export const updateQuestionsRequest = (data, id, currentPage) => {
    return {
        type: UPDATE_QUESTIONS_REQUEST,
        payload: { data: data, id: id, currentPage: currentPage },
    };
};

export const updateQuestionsSuccess = () => {
    return {
        type: UPDATE_QUESTIONS_SUCCESS,
    };
};

export const updateQuestion = (data, id, currentPage) => {
    return async (dispatch) => {
        dispatch(updateQuestionsRequest(data, id, currentPage));
        try {
            const response = await axios.put(
                `/questions/${id}?page=${currentPage}`,
                { data: data }
            );
            dispatch(updateQuestionsSuccess(response.data));
            dispatch(fetchQuestionsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(fetchQuestionsFailure(error.message));
        }
    };
};

export const deleteAllQuestionsRequest = () => {
    return {
        type: DELETE_ALL_QUESTION_REQUEST,
    };
};

export const deleteAllQuestions = () => {
    return async (dispatch) => {
        dispatch(deleteAllQuestionsRequest());
        try {
            const response = await axios.get("/questions/deleteAll");
            dispatch(fetchQuestionsSuccess(response.data));
            dispatch(updateQuestionsSuccess(response.data));
        } catch (error) {
            console.log(error);
            // dispatch(fetchQuestionsFailure(error.message));
        }
    };
};

export const addAnswerRequest = () => {
    return {
        type: ADD_ANSWER_REQUEST,
    };
};

export const addAnswerSuccess = () => {
    return {
        type: ADD_ANSWER_SUCCESS,
    };
};

export const submitAnswer = (data) => {
    return async (dispatch) => {
        dispatch(addAnswerRequest(data));
        try {
            const response = await axios.post("/add-answer", data);
            dispatch(addAnswerRequest(response.data));
            dispatch(fetchQuestionsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(fetchQuestionsFailure(error.message));
        }
    };
};

export const updateAnswerRequest = () => {
    return {
        type: UPDATE_ANSWER_REQUEST
    };
};

export const updateAnswerSuccess = () => {
    return {
        type: UPDATE_ANSWER_SUCCESS
    };
};

export const updateAnswer = (data) => {
    return async (dispatch) => {
        dispatch(updateAnswerRequest(data));
        try {
            const response = await axios.post("/update-answer", data);
            dispatch(updateAnswerRequest(response.data));
            dispatch(fetchQuestionsSuccess(response.data));
        } catch (error) {
            dispatch(fetchQuestionsFailure(error.message));
        }
    };
};

export const exportQuestions = (selectedItems) => {
    return async (dispatch) => {
        try {
            dispatch(questionsExportRequest());

            const response = await axios.post(
                "/questions/export",
                {
                    data: {
                        selectedItems: selectedItems,
                    },
                },
                {
                    responseType: "arraybuffer", // tell Axios to treat the response as binary data
                }
            );

            const blob = new Blob([response.data], { type: "text/csv" });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "questions-and-answers.csv";
            a.click();

            a.remove();
            URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.log(error);
        }
    };
};